import { Table, Select, Tooltip } from "antd";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth.js";
import { useEffect } from "react";
import { DOMAIN, DOMAINCLIENT } from "../Constant.js";
import "antd/dist/antd.min.css";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { AssignToReviewer, PriprityLevel } from "../utilities/Assignto.js";
import usePageVisibility from "../utilities/usePageVisibility";
import axiosInstance from '../utilities/axiosInstance';
import { useWindowManager } from './../hooks/useWindowManager';
import { showAlert } from "./AlertPopup";


const ReviewerData = ({ searchValue }) => {
  const { Option } = Select;
  const { auth } = useAuth();
  const reviewerId =
    auth.profile_username === "admin" ? auth.profile_username : auth.profile_id;
  let [data, setData] = useState([]);
  const [mismatchedTasks, setMismatchedTasks] = useState([]);
  const [portNumber, setPortNumber] = useState();
  let location = useLocation();
  let currentURL = window.location.href;
  let porturl = new URL(currentURL);
  let appPort = porturl.port;
  const [finalData, setFinalData] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  const projectId = urlParams.get('project_id');

  const { redirectToTagging } = useWindowManager();

  let columns = [
    {
      title: (
        <Tooltip title="Task Folder">
          <span>Folder</span>
        </Tooltip>
      ),
      dataIndex: "task_folder_name",
      key: "taskFolderName",
      render: (text, record) => {
        const taskTitles = record.task_title.split(",");

        return (
          <div
            style={{ marginBottom: "8px", display: "flex", flexWrap: "wrap" }}
          >
            {taskTitles.map((titlePart, titleIndex) => (
              <div key={titleIndex} style={{ marginRight: "8px" }}>
                {titlePart}
              </div>
            ))}
          </div>
        );
      },
    },
    {
      title: (
        <Tooltip title="Assign To">
          <span>Assign To</span>
        </Tooltip>
      ),
      dataIndex: "profile_username",
      key: "profileUsername",
      /* render: (text, record, pname) => (
        <AssignToReviewer pname={pname} record={record} mismatchedTasks={mismatchedTasks} />
      ) */
    },
    {
      title: (
        <Tooltip title="No Of Items">
          <span>Items</span>
        </Tooltip>
      ),
      dataIndex: "task_filename",
      key: "noOfItems",
      render: (text, record) => {
        try {
          let numItems = record.numimage > 0 ? record.numimage : record.numdocs;
          const reviewerAppUrl = `${DOMAINCLIENT}/${record.reviewer_profile_id}/${record.task_mediatype}?roleid=${auth.profile_role}&username=${reviewerId}`;

          return (
            <button
              onClick={() => redirectToTagging(record.reviewer_profile_id, record.task_mediatype, reviewerId, auth)}
              className="h-8 w-8 rounded-full bg-[#0fb4d2] text-white text-xs flex items-center justify-center cursor-pointer"
            >
              {numItems}
            </button>
          );

          // return (
          //   <a href={reviewerAppUrl} target="_blank">
          //     {numItems}
          //   </a>
          // );
        } catch (error) {
          console.error("Error rendering number of images:", error);
          return 0; // or display an error message
        }
      },
    },
    {
      title: (
        <Tooltip title="Process Type">
          <span>Process</span>
        </Tooltip>
      ),
      dataIndex: "task_process_type",
      key: "taskProcessType",
    },
    {
      title: (
        <Tooltip title="Status">
          <span>Status</span>
        </Tooltip>
      ),
      dataIndex: "task_status",
      key: "taskStatus",
      render: (text, record) => <StatusSelect record={record} />,
    },
    {
      title: (
        <Tooltip title="Priority Level">
          <span>Priority</span>
        </Tooltip>
      ),
      dataIndex: "task_prioroty",
      key: "priorotyLevel",
      render: (text, record) => <PriprityLevel record={record} />,
    },
    {
      title: (
        <Tooltip title="Modified Date">
          <span>Modified</span>
        </Tooltip>
      ),
      dataIndex: "modifiedDate",
      key: "modified_Date",
    },
    {
      title: (
        <Tooltip title="Task Completion Date">
          <span>Completion</span>
        </Tooltip>
      ),
      dataIndex: "task_completedDate",
      key: "task_completedDate",
    },
  ];


  const getReviewersTask = () => {
    axiosInstance
      .get(`/getreviewertask`, {
        params: {
          profile_id: auth.profile_id,
          profile_role: auth.profile_role,
          project_id: projectId
        },
      })
      .then((response) => {
        setData(response.data);
        setFinalData(response.data);
      })
      .catch((error) => console.error(error));
  };

  const StatusSelect = ({ record }) => {
    const [taskStatus, setTaskStatus] = useState({});
    const [data, setData] = useState([]);

    useEffect(() => {
      setTaskStatus((prevState) => ({
        ...prevState,
        [record.task_id]: record.task_status || "Waiting for review",
      }));
    }, [record]);

    const handleStatusChange = (value) => {
      axiosInstance
        .put(`/updatereviewertask/${record.task_id}`, {
          record: {
            ...record,
            task_role: value === "Reassigned" ? 3 : 4,
            task_status: value,
            reviewer_task_status: value === "Reassigned" ? null : "Completed",
          },
        })
        .then((response) => {
          console.log("Backend response:", response.data);
          showAlert(response.data?.message || "Task updated successfully", "success");

          const updatedData = data.filter((task) => task.task_id !== record.task_id);
          setData(updatedData);
          getReviewersTask();
        })
        .catch((error) => {
          console.log(error)
          showAlert("The task was not updated successfully.", "error");
        });
    };


    return (
      <Select
        value={taskStatus[record.task_id]}
        style={{ width: 120 }}
        onChange={handleStatusChange}
      >
        <Option value="Reassigned">Reassigned</Option>
        <Option value="waiting for review" disabled>
          Waiting for Review{" "}
        </Option>
        <Option value="Completed">Completed</Option>
      </Select>
    );
  };

  useEffect(() => {
    if (searchValue !== "") {
      const newData = data.filter((item) =>
        item?.profile_email?.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFinalData(newData);
    } else {
      setFinalData(data);
    }
  }, [searchValue]);

  useEffect(() => {
    getReviewersTask();
  }, []);

  usePageVisibility(() => {
    getReviewersTask();
  });

  return (
    <div>
      <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 border-b border-gray-d-200 dark:text-white dark:border-white mb-[20px]">Welcome {(auth.profile_name !== 'null') ? auth.profile_name : auth.profile_username} - Reviewer Page</h2>

      <Table
        className="details-view-table"
        //rowSelection={rowSelection}
        columns={columns}
        dataSource={finalData}
        pagination={{ pageSize: 6 }}
      />
    </div>
  );
};

export default ReviewerData;
